import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignInComponent } from './sign-in.component';
import { Route, RouterModule } from '@angular/router';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';
import { TranslocoModule } from '@ngneat/transloco';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { KDividerModule } from 'app/common/ui/k-divider/k-divider.module';
import { InputTextModule } from 'primeng/inputtext';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormCardModule } from 'app/common/ui/form-card/form-card.module';

const authSignInRoutes: Route[] = [
  {
    path: '',
    component: SignInComponent
  }
];

@NgModule({
  declarations: [
    SignInComponent
  ],
  imports: [
    RouterModule.forChild(authSignInRoutes),
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    KButtonModule,
    TranslocoModule,
    InputTextModule,
    KDividerModule,
    FormCardModule,
    FontAwesomeModule
  ],
  exports: [
    SignInComponent
  ]
})
export class SignInModule { }
